// client/src/routes/app/settings/gdpr.tsx — SCR-SET-009 · GDPR-002 (04 §8.18).
//
// The fourth tab of the settings area. §8.18 reserves the path — „SCR-SET-009 | Confidențialitate
// & GDPR | `/app/settings/gdpr` | — | M5 | 05 GDPR-002" — and gates it: „children gate
// individually (SET-003/004/009 `owner` only)".
//
// The guard is `Org.Settings` and not the `owner` role, because that permission is what the
// eleven endpoints behind this screen actually enforce (02 §6.4) and 03 §17.1 grants it to
// `owner` alone — the two are the same set, and the one that mirrors the API is the one that
// stays true if the seed ever changes. The tab in `settings/route.tsx` hides itself on the same
// reading; this is the other half of §9.2.2, for the URL that was typed anyway.

import { createFileRoute } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { PrivacyScreen } from '@/features/gdpr/PrivacyScreen';

export const Route = createFileRoute('/app/settings/gdpr')({
  component: GdprSettingsScreen,
});

function GdprSettingsScreen() {
  return (
    <RequirePermission permission="Org.Settings">
      <PrivacyScreen />
    </RequirePermission>
  );
}
